module.exports = __webpack_public_path__ + "img/HeroTypesQuiz-Q8.87b7a564.png";